import { computed, action } from 'mobx';
import { StoreBase } from '../../../common/StoreBase';
import { IImageConfiguration } from '../models';
import { IImageProps } from '../models/IImageProps';
import { IFundManagerConfiguration } from '../../../models/app/IFundManagerCode';
import { query } from '@kurtosys/ksys-app-template';
import { FundManagerStoreBase } from '../../../common/FundManagerStoreBase';

export class ImageStore extends FundManagerStoreBase {
	static componentKey: 'image' = 'image';

	@computed
	get configuration(): IImageConfiguration | undefined {
		if (this.storeContext && this.storeContext.appStore) {
			return this.storeContext.appStore.getComponentConfiguration(ImageStore.componentKey);
		}
	}

	@action
	async initialize(): Promise<void> {

	}
	@computed
	get baseServiceUrl(): string {
		const { kurtosysApiStore } = this.storeContext;
		return kurtosysApiStore.serviceUrl;
	}

	getPhotoSrc(managerCode: string): string {
		const token = (this.storeContext.appStore.configuration && this.storeContext.appStore.configuration.token) || '';
		const src = `${ this.baseServiceUrl }fund/fundmanagerpicture?code=${ managerCode }&token=${ token }`;
		return src;
	}

	@computed
	get imageProps(): IImageProps | undefined {
		const imageConfiguration = this.configuration;

		if (imageConfiguration) {
			const imageValues = this.mergeQueriesAndProps(imageConfiguration) as IImageConfiguration['props'];

			if (imageValues) {
				return {
					src: this.getPhotoSrc(imageValues.value),
				};
			}
		}

		return;
	}
}